import { createFileRoute, notFound } from "@tanstack/react-router";
import { BlogListPage } from "@/components/blog/BlogPages";
import { blogListHead } from "@/components/blog/blog-head";
import { pageCount, pageOf } from "@/lib/blog";
import { listBlogPosts } from "@/lib/blog.functions";

// Блог (az): список опубликованных статей, ?page= — пагинация. Пусто — «статей пока нет».
export const Route = createFileRoute("/az/bloq/")({
  // Первая страница — без ?page: иначе роутер дописывает ?page=1 и отвечает редиректом.
  validateSearch: (s: Record<string, unknown>): { page?: number } => (pageOf(s.page) > 1 ? { page: pageOf(s.page) } : {}),
  loaderDeps: ({ search }) => ({ page: search.page ?? 1 }),
  loader: async ({ deps }) => {
    const res = await listBlogPosts({ data: { lang: "az", page: deps.page } });
    // Страница за концом списка — 404, а не пустая страница с 200.
    if (deps.page > pageCount(res.total)) throw notFound();
    return { page: deps.page, ...res };
  },
  head: ({ loaderData }) => blogListHead("az", loaderData?.page ?? 1),
  component: function Page() {
    const { page, cards, total } = Route.useLoaderData();
    return <BlogListPage lang="az" page={page} cards={cards} total={total} />;
  },
});
